import { useState } from "react";
import { Outlet } from "react-router";
import BreadcrumbNavigation from "~/components/Breadcrumbs";
import Header from "~/components/Header";
import Toolbar from "~/components/Toolbar";
import AutoSaveStatus from "~/components/AutoSaveStatus";
import { BreadcrumbItem } from "~/types/global";
import { ReportEditControls } from "~/components/ReportEditControls";
import { REPORT_DETAIL_STORE_INSTANCE } from "~/store/details";
import { useReportActionsWithAutoSave } from "~/hooks/useReportActionsWithAutoSave";
import { useBackButtonGuard } from "~/hooks/useBackButtonGuard";

const DefaultLayout = () => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);
  const {
    selectors: {
      useIsPendingSave,
      useHasPendingChanges,
      useIsAutoSaveEnabled,
      useRefetchReport,
    },
    events: { clearPendingChanges },
  } = REPORT_DETAIL_STORE_INSTANCE;
  const refetchReport = useRefetchReport();
  const actions = useReportActionsWithAutoSave(refetchReport || undefined);
  const isSaving = useIsPendingSave();
  const hasPendingChanges = useHasPendingChanges();
  const isAutoSaveEnabled = useIsAutoSaveEnabled();
  const showEditControls = hasPendingChanges && !isAutoSaveEnabled;

  useBackButtonGuard({
    hasUnsavedChanges: hasPendingChanges,
    onConfirmNavigation: clearPendingChanges,
  });

  return (
    <div className="h-screen flex flex-col">
      <Header />
      <div className="px-8 gap-6 flex items-center justify-between flex-wrap">
        <div className="flex-1">
          <BreadcrumbNavigation breadcrumbs={breadcrumbs} />
        </div>
        <div className="flex gap-8 items-center">
          <ReportEditControls
            show={showEditControls}
            onSave={actions.forceSave}
            onCancel={actions.cancelChanges}
            isSaving={isSaving}
          />
          <AutoSaveStatus />
        </div>
      </div>
      <main className="flex-1 flex flex-col min-h-0">
        <div className="w-full px-8 py-4">
          <Toolbar />
        </div>
        <div className="flex-1 w-full">
          <Outlet context={{ setBreadcrumbs }} />
        </div>
      </main>
    </div>
  );
};

export default DefaultLayout;
